import { PcApiResponse } from '@/api/pc-api/types';
import { Settle } from '@/api/pc-api/v1/{authInfoId}/settle/list';
import { PREFIX_PATH } from '@/lib/axios/axiosInterceptor';
import { api } from '@/utils/api';

export const getSettleListForPartner = () => {
  return api<PcApiResponse<Settle[]>>('get', `/pc-api/v1/${PREFIX_PATH}/settle/list-for-partner`);
};
